/* tslint:disable */
/* eslint-disable */
/**
 * AusgabeAutomatConnector
 * Connector für Ausgabeautomat zu ORSY Gateway und BDS Gateway.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CostCenter,
  OrsyItemOnLoan,
  Stock,
  StockMovement,
} from '../models/index';
import {
    CostCenterFromJSON,
    CostCenterToJSON,
    OrsyItemOnLoanFromJSON,
    OrsyItemOnLoanToJSON,
    StockFromJSON,
    StockToJSON,
    StockMovementFromJSON,
    StockMovementToJSON,
} from '../models/index';

export interface FetchStockMovementsRequest {
    eventtimeGte: string;
    eventtimeLte: string;
    reason?: Array<number>;
    costCenters?: Array<string>;
}

/**
 * ReportingApi - interface
 * 
 * @export
 * @interface ReportingApiInterface
 */
export interface ReportingApiInterface {
    /**
     * 
     * @summary Fetches all cost centers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApiInterface
     */
    fetchCostCentersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CostCenter>>>;

    /**
     * Fetches all cost centers
     */
    fetchCostCenters(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CostCenter>>;

    /**
     * 
     * @summary Fetches all Orsy items with stockLevel <1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApiInterface
     */
    fetchOrsyItemsOnLoanRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OrsyItemOnLoan>>>;

    /**
     * Fetches all Orsy items with stockLevel <1
     */
    fetchOrsyItemsOnLoan(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OrsyItemOnLoan>>;

    /**
     * 
     * @summary Fetches current stock levels for all items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApiInterface
     */
    fetchStockRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Stock>>>;

    /**
     * Fetches current stock levels for all items
     */
    fetchStock(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Stock>>;

    /**
     * 
     * @summary Fetches reporting stock movements for given filter
     * @param {string} eventtimeGte Include movements with eventTime &gt;&#x3D; this timestamp.
     * @param {string} eventtimeLte Include movements with eventTime &lt;&#x3D; this timestamp.
     * @param {Array<number>} [reason] Optional list of movement reasons to include.
     * @param {Array<string>} [costCenters] Optional list of cost centers to include.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApiInterface
     */
    fetchStockMovementsRaw(requestParameters: FetchStockMovementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StockMovement>>>;

    /**
     * Fetches reporting stock movements for given filter
     */
    fetchStockMovements(requestParameters: FetchStockMovementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StockMovement>>;

}

/**
 * 
 */
export class ReportingApi extends runtime.BaseAPI implements ReportingApiInterface {

    /**
     * Fetches all cost centers
     */
    async fetchCostCentersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CostCenter>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_auth", []);
        }

        const response = await this.request({
            path: `/api/v1/report/cost-center`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CostCenterFromJSON));
    }

    /**
     * Fetches all cost centers
     */
    async fetchCostCenters(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CostCenter>> {
        const response = await this.fetchCostCentersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Fetches all Orsy items with stockLevel <1
     */
    async fetchOrsyItemsOnLoanRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OrsyItemOnLoan>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_auth", []);
        }

        const response = await this.request({
            path: `/api/v1/report/orsy-items-on-loan`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrsyItemOnLoanFromJSON));
    }

    /**
     * Fetches all Orsy items with stockLevel <1
     */
    async fetchOrsyItemsOnLoan(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OrsyItemOnLoan>> {
        const response = await this.fetchOrsyItemsOnLoanRaw(initOverrides);
        return await response.value();
    }

    /**
     * Fetches current stock levels for all items
     */
    async fetchStockRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Stock>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_auth", []);
        }

        const response = await this.request({
            path: `/api/v1/report/stock`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StockFromJSON));
    }

    /**
     * Fetches current stock levels for all items
     */
    async fetchStock(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Stock>> {
        const response = await this.fetchStockRaw(initOverrides);
        return await response.value();
    }

    /**
     * Fetches reporting stock movements for given filter
     */
    async fetchStockMovementsRaw(requestParameters: FetchStockMovementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StockMovement>>> {
        if (requestParameters.eventtimeGte === null || requestParameters.eventtimeGte === undefined) {
            throw new runtime.RequiredError('eventtimeGte','Required parameter requestParameters.eventtimeGte was null or undefined when calling fetchStockMovements.');
        }

        if (requestParameters.eventtimeLte === null || requestParameters.eventtimeLte === undefined) {
            throw new runtime.RequiredError('eventtimeLte','Required parameter requestParameters.eventtimeLte was null or undefined when calling fetchStockMovements.');
        }

        const queryParameters: any = {};

        if (requestParameters.eventtimeGte !== undefined) {
            queryParameters['eventtimeGte'] = requestParameters.eventtimeGte;
        }

        if (requestParameters.eventtimeLte !== undefined) {
            queryParameters['eventtimeLte'] = requestParameters.eventtimeLte;
        }

        if (requestParameters.reason) {
            queryParameters['reason'] = requestParameters.reason;
        }

        if (requestParameters.costCenters) {
            queryParameters['costCenters'] = requestParameters.costCenters;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_auth", []);
        }

        const response = await this.request({
            path: `/api/v1/report/movements`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StockMovementFromJSON));
    }

    /**
     * Fetches reporting stock movements for given filter
     */
    async fetchStockMovements(requestParameters: FetchStockMovementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StockMovement>> {
        const response = await this.fetchStockMovementsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
